import {Button} from "@/components/ui/button";
import {RiLoader4Fill} from "react-icons/ri";
import {cn} from "@/lib/utils";
import {forwardRef} from "react";


function CWFButton({ className, disabled, loading, children, slotClassName, ...props}, ref){
    return (
        <Button ref={ref} {...props} asChild disabled={loading || disabled} className={slotClassName}>
            <button className={cn("relative", className)}>
                <div className={cn(`flex items-center justify-center ${loading && "invisible"}`, className)}>
                    {children}
                </div>
                <div className={`absolute inset-0 flex items-center justify-center pointer-events-none ${!loading && "invisible"}`}>
                    <RiLoader4Fill className="h-4 w-4 animate-spin" />
                </div>
            </button>
        </Button>
    )
}

export default forwardRef(CWFButton);